import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadTimesheetEntryContractor } from "@/types/timesheetEntryContractor";
import { convertReadTimesheetEntryContractorsToFormContractors } from "../utils/convertReadTimesheetEntryContractorsToFormContractors";

const service = new APIService<ReadTimesheetEntryContractor>(
  API.TimesheetEntries,
);

export const TimesheetEntriesContractorsService = {
  getList: async (
    fetchParams: FetchListRequest<ReadTimesheetEntryContractor>,
  ) => {
    const response = await service.getList(fetchParams, `/contractors`);
    return {
      items: response.items.map(
        convertReadTimesheetEntryContractorsToFormContractors,
      ),
      count: response.count,
    };
  },
};
